import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let getSignInTypeMachine: any;

export const useSMGetSignInType = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  getSignInTypeMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(getSignInTypeMachine);

  // useEffect(() => {
  //   send({ type: 'START' });
  // }, []);

  return {
    getSignInTypeMachine,
    getSignInTypeState: state,
    getSignInTypeSend: send,
  };
};
